// Le message « c'est fait » qui suit une action (audit B3, 28/09/2026).
//
// Il s'affichait en paragraphe AU-DESSUS du tableau, dans le flux de la page :
// il poussait le tableau vers le bas en apparaissant, puis le faisait remonter
// en disparaissant 6 a 8 secondes plus tard -- SOUS LE CURSEUR, au moment ou
// l'on visait la ligne suivante. Un clic prevu pour une ligne tombait sur une
// autre. Quatre ecrans suivaient ce motif : Stock, Utilisateurs, Financement,
// Plateforme.
//
// Il flotte desormais en bas de l'ecran et ne prend AUCUNE place dans la page.
// `role="status"` : un lecteur d'ecran l'annonce sans voler le focus.
export default function Notification({ message }) {
  if (!message) return null;
  return (
    <p className="notification-flottante" role="status">
      {message}
    </p>
  );
}
